import React from 'react';
import { colors } from './settings.js';
import * as TWEEN from '@tweenjs/tween.js';

import './Stacks.css';

export default class Stacks extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      cityLevelTweenAmount: 0,
    }
    const tweenedVariable = { cityLevelTweenAmount: 0}
    this.tween = new TWEEN.Tween(tweenedVariable)
      .onUpdate(() => {
        this.setState({ cityLevelTweenAmount: tweenedVariable.cityLevelTweenAmount })
      })
      .easing(TWEEN.Easing.Cubic.InOut)
  }

  componentWillUnmount() {
    this.tween.stop()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.level !== this.props.level) {
      const targetTweenValue = this.props.level === 'state' ? 0 : 1
      this.tween.stop()
      this.tween.to({ cityLevelTweenAmount: targetTweenValue}, 300)
        .start()
    }
  }

  render() {
    return (
      Object.keys(this.props.data).map(dataKey => {
        const pointerEvents = this.props.zooming || dataKey !== this.props.level ? 'none' : 'auto'
        const data = this.props.data[dataKey]
        const stacks = data.map(d => {
          let x = d.screen.x;
          let y = d.screen.y;
          if (dataKey === 'city') {
            // we are plotting the city stacks, but we want them to appear at the state position
            // so we can animate them smoothly
            x = x * this.state.cityLevelTweenAmount + d.matchingState.screen.x * (1 - this.state.cityLevelTweenAmount)
            y = y * this.state.cityLevelTweenAmount + d.matchingState.screen.y * (1 - this.state.cityLevelTweenAmount)
          }
          return (
            <g
              key={d.key}
              id={d.key}
              className='stack'
              transform={`
                translate(${x}, ${y + 0.35})
                scale(${1 / this.props.scale})
              `}
              style={{
                pointerEvents,
              }}
              onClick={() => {
                if (d.level === 'state') {
                  this.props.setGeo(d.key)
                } else {
                  this.props.setGeo(d.matchingState.key)
                }
              }}
              onMouseOut={this.props.closeTooltip}
            >
              {
                (dataKey === 'state') ? (
                  d.groups.map(g => {
                    return (
                      <path
                        key={g.key}
                        id={g.key}
                        d={g.path}
                        fill={g.settings[g.fillType]}
                        stroke={colors.grey.darkest}
                        onMouseOver={this.props.openTooltip(d)}
                        onTouchEnd={this.props.openTooltip(d)}
                      />
                    )
                  })
                ) : (
                  d.groups.map(g => {
                    return g.values.map((v, i) => {
                      return (
                        <path
                          className='leaflet'
                          key={`${g.key}-${i}`}
                          id={`${g.key}-${i}`}
                          d={v.path}
                          fill={g.settings[v.fillType]}
                          stroke={colors.grey.darkest}
                          onMouseOver={this.props.openTooltip(d, v)}
                          onTouchEnd={this.props.openTooltip(d, v)}
                        />
                      )
                    })
                  })
                )
              }
            </g>
          )
        })
        return (
          <g
            key={dataKey}
            className='stackDataLevel'
            style={{ opacity: dataKey === this.props.level ? 1 : 0 }}
          >
            {stacks}
          </g>
        );
      })
    );
  }
}